/**
 * A column header that sorts the listing (TRA-1091, shared since
 * TRA-1397). The active column shows the direction; a click on it flips
 * the direction, a click on another column moves the sort there.
 */

import { ArrowDown, ArrowUp } from 'lucide-react'

import { TableHead } from '@/components/ui/table'

import type { SortState } from './listingParams'

interface SortHeaderProps<F extends string> {
  field: F
  label: string
  sort: SortState<F>
  onSort: (field: F) => void
  alignRight?: boolean
}

export function SortHeader<F extends string>({
  field,
  label,
  sort,
  onSort,
  alignRight,
}: SortHeaderProps<F>): React.JSX.Element {
  const active = sort.field === field
  return (
    <TableHead className={alignRight ? 'text-right' : undefined}>
      <button
        type="button"
        onClick={() => {
          onSort(field)
        }}
        aria-label={`Sort by ${label}`}
        aria-pressed={active}
        // Buttons reset text-transform, so restate the header's uppercase.
        className={`inline-flex items-center gap-1 uppercase hover:text-foreground ${
          active ? 'text-foreground' : ''
        }`}
      >
        {label}
        {active &&
          (sort.desc ? (
            <ArrowDown className="h-3 w-3" />
          ) : (
            <ArrowUp className="h-3 w-3" />
          ))}
      </button>
    </TableHead>
  )
}
